import { render, staticRenderFns } from "./IndexShipmentlLeader.vue?vue&type=template&id=17adc9cb&scoped=true&"
import script from "./IndexShipmentlLeader.vue?vue&type=script&lang=js&"
export * from "./IndexShipmentlLeader.vue?vue&type=script&lang=js&"
import style0 from "./IndexShipmentlLeader.vue?vue&type=style&index=0&id=17adc9cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17adc9cb",
  null
  
)

export default component.exports